// src/IconPaperplaneFill.tsx
import { forwardRef } from "react";
import { jsx } from "react/jsx-runtime";
var Icon = ({
  size = 24,
  ...props
}, ref) => /* @__PURE__ */ jsx(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "data-seed-icon": "true",
    "data-seed-icon-version": "0.0.23",
    width: size,
    height: size,
    ref,
    ...props,
    children: /* @__PURE__ */ jsx("g", { children: /* @__PURE__ */ jsx(
      "path",
      {
        d: "M20.3156 13.6958L20.3184 13.6944C21.7262 12.9881 21.6824 11.0057 20.3248 10.3061L3.76764 1.90077C3.45188 1.74047 3.07047 1.78756 2.80317 2.01983C2.53587 2.25211 2.43603 2.62323 2.5507 2.95827C3.31118 5.18007 3.69382 7.09888 3.81734 9.16069C3.87509 10.1777 4.73091 10.9403 5.71691 10.9297L11.4601 10.9157L11.4639 10.9157C12.0561 10.9117 12.5436 11.3992 12.5395 11.9913L12.5395 11.9974C12.5396 12.605 12.0536 13.0823 11.465 13.078L5.70399 13.0694C4.72423 13.0692 3.86888 13.8123 3.81093 14.8381C3.68822 16.8999 3.30633 18.8186 2.54671 21.0401C2.43215 21.3752 2.53206 21.7462 2.79934 21.9784C3.06663 22.2106 3.44797 22.2577 3.76369 22.0974L20.3156 13.6958Z",
        fill: "currentColor"
      }
    ) })
  }
);
var IconPaperplaneFill = forwardRef(Icon);
var IconPaperplaneFill_default = IconPaperplaneFill;
export {
  IconPaperplaneFill_default as default
};
